
/* ============================== src/components/discussion/emojiStyle.js ============================== */
// src/components/discussion/emojiStyle.js

/**
 * Единая точка правды для отрисовки эмодзи в обсуждении: стиль спрайта,
 * два размера и базовый URL спрайтов.
 *
 * Стиль и размеры вынесены сюда, а не оставлены по месту, потому что
 * используются в двух компонентах - ReactionPicker (крупные эмодзи
 * в попапе выбора) и CommentReactions (компактные чипы под
 * комментарием). Если задать независимо, они разъедутся при первой
 * правке.
 *
 * getEmojiUrl подменяет внешний CDN (cdn.jsdelivr.net) на локальную
 * раздачу из public/emoji/apple/. Без этого в закрытой корпоративной
 * сети спрайты не загружаются и вместо эмодзи остаются пустые
 * картинки - важно для production, где нет выхода в интернет.
 */

/** Стиль спрайтов эмодзи. 'apple' | 'google' | 'facebook' | 'twitter' | 'native'. */
export const EMOJI_STYLE = "apple";

/** Размер эмодзи в попапе выбора реакции. */
export const EMOJI_SIZE_PICKER = 20;

/** Размер эмодзи в чипе уже поставленной реакции. */
export const EMOJI_SIZE_CHIP = 14;

/**
 * URL одного PNG-спрайта.
 *
 * BASE_URL - встроенная переменная Vite: '/' для приложения в корне
 * домена или '/planning/' и т. п. Благодаря ей путь работает и при
 * деплое в подпапку, а не только в корне.
 *
 * @param {string} unified - id эмодзи, например '1f44d'
 * @param {string} style   - стиль ('apple')
 * @returns {string} полный путь к PNG
 */
export const getEmojiUrl = (unified, style) =>
  `${import.meta.env.BASE_URL}emoji/${style}/64/${unified}.png`;
